import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as RewardService from '_services/rewards-service';

export const getDateOneWeekAgo = (currentDate) => {
  // Get the current timestamp
  const currentTimestamp = currentDate.getTime();

  // Calculate the timestamp for 7 days ago (7 * 24 * 60 * 60 * 1000 milliseconds)
  const sevenDaysAgoTimestamp = currentTimestamp - 604800000;

  // Create a new date object from the timestamp for 7 days ago
  const sevenDaysAgo = new Date(sevenDaysAgoTimestamp);

  return sevenDaysAgo;
}

const initialState = {
  transaction: {},
  status: 'idle',
  updateStatus: 'idle',
  error: null,
  purchaseOption: "ALL",
  rangeDate: [
    getDateOneWeekAgo(new Date()),
    new Date()
  ],

  currentPage: 1,
  rowsPerPage: 10,
  searchValue: ""
};
/* fetch transaction data */
export const getTransaction = createAsyncThunk('transaction/getTransaction', async (id) => {
  return RewardService.getTransaction(id);
})

export const updateTransaction = createAsyncThunk('transaction/updateTransaction', async (transaction) => {
  return RewardService.updateTransaction(transaction);
})

const transactionSlice = createSlice({
  name: 'transaction',
  initialState,
  reducers: {
    reset: (state) => initialState,
    setSelectedPurchasesOption: (state, action) => {
      return {
        ...state,
        purchaseOption: action.payload
      }
    },
    setSelectedRangeDate: (state, action) => {

      return {
        ...state,
        rangeDate: action.payload
      }
    },
    resetUpdateTransaction: (state) => {
      return {
        ...state,
        updateStatus: "idle"
      }
    },
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    setRowsPerPage(state, action) {
      state.rowsPerPage = action.payload;
    },
    setSearchValue: (state, action) => {
      state.searchValue = action.payload
    },
    resetSearchValue: (state) => {
      state.searchValue = ""
    }

  },
  extraReducers: {
    [getTransaction.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
      }
    },
    [getTransaction.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        transaction: action.payload,
      }
    },
    [getTransaction.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        error: action.error.message,
      }
    },
    [updateTransaction.pending]: (state, action) => {
      return {
        ...state,
        updateStatus: 'loading',
      }
    },
    [updateTransaction.fulfilled]: (state, action) => {
      return {
        ...state,
        updateStatus: 'succeeded',
        transaction: action.payload,
      }
    },
    [updateTransaction.rejected]: (state, action) => {
      return {
        ...state,
        updateStatus: 'failed',
        error: action.error.message,
      }
    },
  }
});

export const { reset, setSelectedPurchasesOption, setSelectedRangeDate, resetUpdateTransaction, setCurrentPage, setRowsPerPage, setSearchValue, resetSearchValue } = transactionSlice.actions;
export const selectTransaction = state => state.transaction.transaction;
export const selectDataRange = state => state.transaction.rangeDate;
export const selectPurchasesOption = state => state.transaction.purchaseOption;
export const selectUpdateTransactionStatus = state => state.transaction.updateStatus;
export const selectCurrentPage = state => state.transaction.currentPage;
export const selectRowsPerPage = state => state.transaction.rowsPerPage;
export const selectSearchValue = state => state.transaction.searchValue;

export default transactionSlice.reducer;
